import { LOGO_URL } from "../KeshaMark";

export default function StartScreen({ onStart, onResume, hasProgress, onRequestClear }) {
  return (
    <section className="ks-rise pt-2 pb-10">
      <div className="flex flex-col items-start gap-10">
        <div className="ks-rise ks-rise-1">
          <img
            src={LOGO_URL}
            alt="Kesha Speaks"
            className="w-auto h-[56px] sm:h-[72px] object-contain"
            data-testid="start-logo"
          />
        </div>

        <div className="ks-rise ks-rise-2">
          <p className="ks-badge mb-4">A private worksheet</p>
          <h1 className="ks-h1" data-testid="start-title">
            The <span style={{ color: "var(--ks-fuchsia)", fontStyle: "italic" }}>“Am I Tripping?”</span>
            <br />Clarity Check
          </h1>
        </div>

        <p
          className="ks-rise ks-rise-3 text-[18px] sm:text-[20px] leading-[1.5] text-[color:var(--ks-ink-soft)] max-w-[560px]"
          data-testid="start-subtitle"
        >
          A reusable tool for sorting facts, feelings, patterns, and next steps —
          before you spiral, overexplain, or send that paragraph.
        </p>

        <div
          className="ks-rise ks-rise-3 max-w-[560px] space-y-5 text-[17px] leading-[1.65] text-[color:var(--ks-ink)]"
          data-testid="start-intro"
        >
          <p className="font-elite tracking-[0.06em] text-[15px] sm:text-[16px] text-[color:var(--ks-fuchsia)]">
            Before we make this a federal case, let's sort the information.
          </p>
          <p>
            This tool is for the moment when something happened, you feel activated, and now you're trying to figure out if you're reacting to the actual situation or everything that situation brought up.
          </p>
          <p className="text-[color:var(--ks-ink-soft)]">
            You are not here to invalidate yourself.
          </p>
          <p>
            You are here to separate what happened from what you're afraid it means, what keeps repeating, and what your next clean move needs to be.
          </p>
        </div>

        <div className="ks-rise ks-rise-4 flex flex-col sm:flex-row gap-3 pt-2 w-full sm:w-auto">
          <button
            className="ks-btn ks-btn-primary w-full sm:w-auto"
            onClick={onStart}
            data-testid="start-begin-btn"
          >
            Start the check →
          </button>
          {hasProgress && (
            <button
              className="ks-btn ks-btn-ghost w-full sm:w-auto"
              onClick={onResume}
              data-testid="start-resume-btn"
            >
              Resume where I left off
            </button>
          )}
        </div>

        <div className="ks-rise ks-rise-5 pt-6 max-w-[560px] w-full border-t ks-hair">
          <p className="pt-6 text-[14px] leading-[1.6] text-[color:var(--ks-ink-mute)]" data-testid="start-privacy">
            <span className="ks-badge" style={{ color: "var(--ks-ink-soft)" }}>Privacy</span><br />
            Your answers are saved on this device only. Kesha Speaks does not receive or review your entries.
          </p>
          {hasProgress && (
            <button
              className="mt-4 font-elite uppercase tracking-[0.08em] text-[13px] text-[color:var(--ks-fuchsia)] hover:underline"
              onClick={onRequestClear}
              data-testid="start-clear-btn"
            >
              Clear saved answers
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
